import { render, staticRenderFns } from "./ResourceBank.vue?vue&type=template&id=8b3adfd6&scoped=true&"
import script from "./ResourceBank.vue?vue&type=script&lang=js&"
export * from "./ResourceBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3adfd6",
  null
  
)

export default component.exports